import type { IconData } from '@stacksjs/iconify-core'

export const skull2Solid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M24 1.5C12.278 1.5 2.5 10.086 2.5 21c0 9.203 6.973 16.767 16.17 18.896q.042.723.085 1.298c.176 2.317 1.723 4.292 4.166 4.705c.546.093 1.18.183 1.915.264a1.5 1.5 0 0 0 1.664-1.491V42a1.5 1.5 0 0 1 3 0v2.995a1.5 1.5 0 0 0 1.484 1.5a93 93 0 0 0 3.05-.017a1.5 1.5 0 0 0 1.466-1.5V42a1.5 1.5 0 0 1 3 0v2.548a1.5 1.5 0 0 0 1.707 1.485q.469-.065.872-.134c2.443-.413 3.99-2.387 4.165-4.705c.134-1.766.256-4.517.256-8.694V20q-.001-.21-.055-.403C44.644 9.354 35.218 1.5 24 1.5M42.5 23c0-2.753-1.811-4.5-3.5-4.5s-3.5 1.747-3.5 4.5s1.812 4.5 3.5 4.5s3.5-1.747 3.5-4.5m-21 0c0-2.61 1.911-4.5 4-4.5s4 1.89 4 4.5s-1.911 4.5-4 4.5s-4-1.89-4-4.5\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default skull2Solid
